import React from 'react';
import me from '../../assets/images/me.jpg';
import me2 from '../../assets/images/me2.png';
import { AiFillGithub, AiFillLinkedin, AiOutlineTwitter, AiOutlineMail } from 'react-icons/ai';

const Home = () => {
    return (
        <div id='home' className='lg:h-screen flex justify-center items-center bg-[#f9f9f9] py-24 lg:py-40 px-6 md:px-12 lg:px-2'>
            <div className='lg:max-w-[1100px] mx-auto flex gap-10 flex-col-reverse md:flex-row justify-between items-center '>

                <div>
                    <h3 className='tracking-wider text-lg mt-5'>Hi, my name is</h3>
                    <h1 className='text-4xl lg:text-5xl  font-bold mt-5'>Bikash Devsharma.</h1>
                    <h1 className='text-4xl lg:text-5xl  font-bold mt-5'>I build things for the web.</h1>
                    <p className='text-lg my-8 text-justify'>I'm a front-end developer, dedicated to creating accessible and user-centered  digital experiences. My portfolio showcases a blend of design and code that captivates and engages users. Let's craft exceptional web journeys together!</p>


                    {/* links  */}

                    <div className=' flex gap-5 items-center py-3'>
                        <a href="https://github.com/Bikash-Dev-Bk" target='_blank' rel="noreferrer" ><AiFillGithub className='text-3xl hover:text-[#2979ff] duration-300 transition ' /></a>
                        <a href="https://www.linkedin.com/in/bikash-devsharma/" target='_blank' rel="noreferrer"><AiFillLinkedin className='text-3xl hover:text-[#2979ff] duration-300 transition' /></a>
                        <a href="https://twitter.com/BikashDevSharma" target='_blank' rel="noreferrer"><AiOutlineTwitter className='text-3xl hover:text-[#2979ff] duration-300 transition' /></a>
                        <a href="mailto:bikashdevsharma99@gmail.com" target='_blank' rel="noreferrer"><AiOutlineMail className='text-3xl hover:text-[#2979ff] duration-300 transition' /></a>
                    </div>
                </div>

                <div >
                    {/* <img src={me} alt="" className='max-w-[250px] md:max-w-[300px] lg:max-w-[400px] rounded-[50%] pt-16 lg:pt-0' /> */}
                    <img src={me2} alt="" className='max-w-[250px] md:max-w-[300px] lg:max-w-[400px] rounded-[50%] pt-16 lg:pt-0' />
                </div>
            </div>
        </div>
    );
};

export default Home;